
import './App.css';

import {Hero,Showcase,Consultant,Stats,Projects,Services,Reviews,Team,Footer} from "./components/Files"



function App() {
  return (
    <div>
      
      <Hero />
      <Consultant />
      <Showcase />
      <Stats />
      <Projects />
      <Services />
      <Reviews />
      <Team />
      <Footer />
      
    </div>
  );
}

export default App;
